import ActionFetch from './ActionFetch.vue'
import ActionTooltip from './ActionTooltip.vue'

export default {
    ActionFetch,
    ActionTooltip,
}